/**
 * Replaces {0}, {1}, … tokens in a localized template with the given values.
 *
 * Uses a replacer function so `$`-sequences in the values are inserted
 * literally — a plain string replacement would interpret `$&`, `` $` `` and
 * friends, corrupting labels built from URL segments or user-visible text.
 *
 * @param template localized string containing {n} tokens
 * @param args values to substitute by index
 * @returns the formatted string
 */
export const formatTemplate = (template: string, ...args: Array<string | number>): string =>
  template.replace(/\{(\d+)\}/g, (match, index) => {
    const value = args[Number(index)];
    return value == null ? match : String(value);
  });
